module.exports = __webpack_public_path__ + "img/Group3-en.f1e35612.png";